import React from 'react';
import BrandingPanel from '../components/BrandingPanel';
import Login from '../components/LoginForm';

const LoginPage: React.FC = () => (
  <div style={{ 
    display: 'flex', 
    minHeight: '100vh', 
    width: '100%',
    overflow: 'hidden'
  }}>
    <BrandingPanel />
    <div style={{ 
      flex: 1, 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      background: '#fff',
      minWidth: 0 // Allow flex item to shrink below content size
    }}>
      <Login />
    </div>
  </div>
);

export default LoginPage;